import { render, staticRenderFns } from "./spreedly.vue?vue&type=template&id=22ec1317&scoped=true"
import script from "./spreedly.vue?vue&type=script&lang=js"
export * from "./spreedly.vue?vue&type=script&lang=js"
import style0 from "./spreedly.vue?vue&type=style&index=0&id=22ec1317&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ec1317",
  null
  
)

export default component.exports